<div class="contact-us-form__content">
  <div class="contact-us-form__content__text">
    <h1 class="contact-us-form__content__text__title">
      {{ language.CONTACT_SUPPORT_FORM_TITLE | translate }}
    </h1>
    <p>{{ language.CONTACT_SUPPORT_FORM_DESCRIPTION | translate }}</p>
    <p>{{ language.CONTACT_SUPPORT_FORM_INDICATION | translate }}</p>
  </div>
  <div class="contact-us-form__content__image__container">
    <img
      class="contact-us-form__content__image__container__image"
      role="presentation"
      alt=""
      src="./assets/images/dog-and-cat.png"
    />
  </div>
  <form
    id="contact-us-form"
    [formGroup]="contactForm"
    (submit)="onSubmit()"
    class="contact-us-form__content__form"
  >
    <div class="contact-us-form__content__form__form-field half-width">
      <rc-field
        [error]="getErrorMessage(contactUsFormFieldEnum.FIRSTNAME) | translate"
        [formControlName]="contactUsFormFieldEnum.FIRSTNAME"
        [id]="contactUsFormFieldEnum.FIRSTNAME"
        [label]="language.CONTACT_SUPPORT_FORM_FIRST_NAME | translate"
        [maxlength]="50"
        [required]="true"
        [type]="'text'"
        class="half-width"
        data-cs-mask
      ></rc-field>
    </div>
    <div class="contact-us-form__content__form__form-field half-width">
      <rc-field
        [error]="getErrorMessage(contactUsFormFieldEnum.LASTNAME) | translate"
        [formControlName]="contactUsFormFieldEnum.LASTNAME"
        [id]="contactUsFormFieldEnum.LASTNAME"
        [label]="language.CONTACT_SUPPORT_FORM_LAST_NAME | translate"
        [maxlength]="50"
        [required]="true"
        [type]="'text'"
        class="half-width"
        data-cs-mask
      ></rc-field>
    </div>
    <div class="contact-us-form__content__form__form-field">
      <rc-field
        [error]="getErrorMessage(contactUsFormFieldEnum.EMAIL) | translate"
        [formControlName]="contactUsFormFieldEnum.EMAIL"
        [id]="contactUsFormFieldEnum.EMAIL"
        [label]="language.CONTACT_SUPPORT_FORM_EMAIL | translate"
        [required]="true"
        [type]="'email'"
        class="full-width"
        data-cs-mask
      ></rc-field>
    </div>
    <div class="contact-us-form__content__form__form-field">
      <rc-select
        [error]="getErrorMessage(contactUsFormFieldEnum.COUNTRY) | translate"
        [formControlName]="contactUsFormFieldEnum.COUNTRY"
        [id]="contactUsFormFieldEnum.COUNTRY"
        [items]="countryList"
        [label]="language.CONTACT_SUPPORT_FORM_COUNTRY | translate"
        [required]="true"
        class="full-width"
      ></rc-select>
    </div>
    <div class="contact-us-form__content__form__form-field">
      <rc-select
        [error]="
          getErrorMessage(contactUsFormFieldEnum.PLATFORM_NAME) | translate
        "
        [formControlName]="contactUsFormFieldEnum.PLATFORM_NAME"
        [id]="contactUsFormFieldEnum.PLATFORM_NAME"
        [items]="platformsList"
        [label]="language.CONTACT_SUPPORT_FORM_PLATFORM_NAME | translate"
        [required]="true"
        class="full-width"
      ></rc-select>
    </div>
    <div class="contact-us-form__content__form__form-field">
      <rc-select
        [customSort]="issueTypesSort"
        [error]="getErrorMessage(contactUsFormFieldEnum.ISSUE_TYPE) | translate"
        [formControlName]="contactUsFormFieldEnum.ISSUE_TYPE"
        [id]="contactUsFormFieldEnum.ISSUE_TYPE"
        [items]="issueTypeList"
        [label]="language.CONTACT_SUPPORT_FORM_TYPE_ISSUES | translate"
        [required]="true"
        class="full-width"
      ></rc-select>
    </div>
    <div class="contact-us-form__content__form__textarea-container">
      <rc-textarea
        [formControlName]="contactUsFormFieldEnum.MESSAGE"
        [id]="contactUsFormFieldEnum.MESSAGE"
        [label]="language.CONTACT_SUPPORT_FORM_COMMENT | translate"
        [maxlength]="'800'"
        [ngClass]="{
          'contact-us-form__content__form--message-required': isMessageRequired,
        }"
        [required]="isMessageRequired"
        class="full-width"
      ></rc-textarea>
      @if (contactForm.get(contactUsFormFieldEnum.MESSAGE)?.errors?.required) {
        <div class="rc-field__error">
          {{ language.ERROR_EMPTY_MESSAGE | translate }}
        </div>
      }
    </div>
    <p>
      <span class="contact-us-form__content__form__mandatory-indicator">*</span>
      {{ language.MANDATORY_INDICATION | translate }}
    </p>

    <div class="contact-us-form__content__form__button">
      @if (showCancelLink) {
        <a id="cancelButton" (click)="cancelForm()" class="rc-link">{{
          language.CONTACT_SUPPORT_FORM_CANCEL_BUTTON | translate
        }}</a>
        <p>{{ language.TEXT_OR | translate }}</p>
      }
      <rc-button
        id="contactUsSubmitButton"
        [disabled]="!contactForm.valid || isSubmitted"
        [loading]="isSubmitted"
        [name]="language.CONTACT_SUPPORT_FORM_SEND_BUTTON | translate"
        type="submit"
      ></rc-button>
    </div>
  </form>
</div>
